import { 
  ChefHat, 
  Bath, 
  Building2, 
  Factory, 
  Home, 
  Wrench 
} from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  'chef-hat': ChefHat,
  'bath': Bath,
  'building': Building2,
  'factory': Factory,
  'home': Home,
  'wrench': Wrench,
};

const serviceKeyMap = {
  '1': 'kitchen',
  '2': 'bathroom',
  '3': 'homeExtensions',
  '4': 'industrial',
  '5': 'commercial',
  '6': 'maintenance'
};

export const ServiceCard = ({ service, className = '' }) => {
  const { t, language } = useLanguage();
  const Icon = iconMap[service.icon] || Wrench;
  
  // Get translated content if available
  const serviceKey = serviceKeyMap[service.id];
  const translatedService = serviceKey ? t(`servicesList.${serviceKey}`) : null;
  
  const title = translatedService?.title || service.title;
  const description = translatedService?.desc || service.description;
  const features = translatedService?.features || service.features;

  // Format title with line break for "Home Extensions & Detached Garages"
  const formatTitle = (titleText) => {
    if (titleText.includes('& Detached Garages')) {
      return (
        <>
          Home Extensions<br />& Detached Garages
        </>
      );
    }
    if (titleText.includes('& garages détachés')) {
      return (
        <>
          Extensions de maison<br />& garages détachés
        </>
      );
    }
    return titleText;
  };

  return (
    <div 
      className={`service-card bg-card border border-border/60 p-8 rounded-lg h-full flex flex-col ${className}`}
      data-testid={`service-card-${service.id}`}
    >
      <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6">
        <Icon className="h-7 w-7 text-primary" />
      </div>
      
      <h3 className="text-xl font-medium mb-3 min-h-[3.5rem]">{formatTitle(title)}</h3>
      <p className="text-muted-foreground mb-6 leading-relaxed flex-grow">{description}</p>
      
      <ul className="space-y-2 mt-auto">
        {features.slice(0, 4).map((feature, index) => (
          <li key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
            <span className="w-1.5 h-1.5 bg-secondary rounded-full shrink-0" />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};
